module.exports = __webpack_public_path__ + "static/media/29BDOS21.1ff5b6c7.jpg";